import { EDocumentStatus, EDocumentType } from '@if/core/types'

export enum ESessionStorageKeys {
  PREQUAL_INFO = 'prequalInfo',
  COAPPLICANT_INFO = 'coapplicantInfo',
}

export enum EReviewLink {
  Medicard = 'https://g.page/r/CYpoFarvZlYMEBI/review',
  IFinance = 'https://g.page/r/CbeNfU0EirsoEBE/review',
}

export enum ESupplementalLoanRefusalReasons {
  UnderMinimalAmount = 'UnderMinimalAmount',
  CreditRepportExpired = 'CreditRepportExpired',
  DocumentsAreScanning = 'DocumentsAreScanning',
  OnGoingCreditApplication = 'OnGoingCreditApplication',
}

export enum ExceptionErrorCode {
  DuplicateException = 'DuplicateException',
  InvalidLoanPurpose = 'InvalidLoanPurpose',
}

const PhoneNumber = '1-888-689-9876'
export const Constants = {
  PhoneNumber,
  PhoneNumberLink: `tel:${PhoneNumber.replace(/-/g, '')}`,

  FinanceFeeRateForRegular: 0.06,
  UpperThresholdAgeForApplicant: 75,
  UpperThresholdAgeForCoapplicant: 75,
  BaseMinTerm: 12,
  BaseMaxTerm: 72,
  CorrectedMaxTerm: 60,
  MinIncomes: 21000,
  MaxIncomes: 1000000,
  MinLoanAmount: 500,
  MaxLoanAmount: 40000,
  MaxRate: 29.99,
  LargeLoanAmount: 10000,
  LongTerm: 84,
  MaxTermUnderAmountThreshold: 60,
  AmountThresholdForLowerTerm: 3000,
  MaxMonthUnderOneYear: 11,
  SupportedDocumentTypes: '.jpg, .jpeg, .png, .pdf, .heic, .heif',

  monthNames: {
    1: { nameEn: 'January', nameFr: 'Janvier' },
    2: { nameEn: 'February', nameFr: 'Février' },
    3: { nameEn: 'March', nameFr: 'Mars' },
    4: { nameEn: 'April', nameFr: 'Avril' },
    5: { nameEn: 'May', nameFr: 'Mai' },
    6: { nameEn: 'June', nameFr: 'Juin' },
    7: { nameEn: 'July', nameFr: 'Juillet' },
    8: { nameEn: 'August', nameFr: 'Août' },
    9: { nameEn: 'September', nameFr: 'Septembre' },
    10: { nameEn: 'October', nameFr: 'Octobre' },
    11: { nameEn: 'November', nameFr: 'Novembre' },
    12: { nameEn: 'December', nameFr: 'Décembre' },
  } as Record<number, { nameEn: string; nameFr: string }>,

  IncomeProofTypes: [
    EDocumentType.LastPayStubJob,
    EDocumentType.FamilyAllocationsProof,
    EDocumentType.WorkIncidentIndemnisationProof,
    EDocumentType.MaternityPaternityIncomeProof,
    EDocumentType.OtherIncomeProof,
    EDocumentType.RetirementIncomeProof,
    EDocumentType.DisabilityIncomeProof,
    EDocumentType.AssistanceProof,
    EDocumentType.EmployementInsuranceProof,
    EDocumentType.T4,
    EDocumentType.T4E,
    EDocumentType.NoticeOfAssessment,
    EDocumentType.ProofOfIncome,
    EDocumentType.ProofOfBenefits,
    EDocumentType.ChildTaxBenefitStatement,
    EDocumentType.MaternityLeaveBenefit,
  ],

  ExpectingDocumentStatuses: [EDocumentStatus.AwaitingDocument, EDocumentStatus.Incomplete, EDocumentStatus.Refused],
}
